import { z } from 'zod';

/** CodeGroupCreate — POST /api/eraf/codes/groups */
export const codeGroupCreateSchema = z.object({
  groupCode: z
    .string()
    .min(1, '그룹 코드를 입력해주세요')
    .max(64, '그룹 코드는 64자 이하여야 합니다')
    .regex(/^[A-Z][A-Z0-9_]*$/, '그룹 코드는 대문자와 밑줄, 숫자만 사용 가능합니다 (예: USER_STATUS)'),
  groupName: z
    .string()
    .min(1, '그룹 이름을 입력해주세요')
    .max(128, '그룹 이름은 128자 이하여야 합니다'),
  description: z
    .string()
    .max(512, '설명은 512자 이하여야 합니다')
    .optional(),
  systemManaged: z.boolean().optional().default(false),
});

export type CodeGroupCreateFormValues = z.infer<typeof codeGroupCreateSchema>;

/** CodeGroupUpdate — PATCH /api/eraf/codes/groups/{groupCode} */
export const codeGroupUpdateSchema = z.object({
  groupName: z
    .string()
    .min(1, '그룹 이름을 입력해주세요')
    .max(128, '그룹 이름은 128자 이하여야 합니다')
    .optional(),
  description: z
    .string()
    .max(512, '설명은 512자 이하여야 합니다')
    .optional(),
});

export type CodeGroupUpdateFormValues = z.infer<typeof codeGroupUpdateSchema>;

/** CodeItemCreate — POST /api/eraf/codes/groups/{groupCode}/items */
export const codeItemCreateSchema = z.object({
  codeValue: z
    .string()
    .min(1, '코드 값을 입력해주세요')
    .max(64, '코드 값은 64자 이하여야 합니다')
    .regex(/^[A-Z][A-Z0-9_]*$/, '코드 값은 대문자와 밑줄, 숫자만 사용 가능합니다 (예: ACTIVE)'),
  defaultLabel: z
    .string()
    .min(1, '기본 라벨을 입력해주세요')
    .max(256, '기본 라벨은 256자 이하여야 합니다'),
  labelKey: z
    .string()
    .max(128, 'i18n 키는 128자 이하여야 합니다')
    .optional(),
  sortOrder: z
    .number({ invalid_type_error: '표시 순서는 숫자여야 합니다' })
    .int('정수로 입력해주세요')
    .min(0, '0 이상이어야 합니다')
    .optional()
    .default(0),
  useYn: z.boolean().optional().default(true),
  extraAttrs: z
    .string()
    .max(2000, '확장 속성은 2000자 이하여야 합니다')
    .optional(),
});

export type CodeItemCreateFormValues = z.infer<typeof codeItemCreateSchema>;

/** CodeItemUpdate — PATCH /api/eraf/codes/groups/{groupCode}/items/{itemCode} */
export const codeItemUpdateSchema = z.object({
  defaultLabel: z
    .string()
    .min(1, '기본 라벨을 입력해주세요')
    .max(256, '기본 라벨은 256자 이하여야 합니다')
    .optional(),
  labelKey: z
    .string()
    .max(128, 'i18n 키는 128자 이하여야 합니다')
    .optional(),
  sortOrder: z
    .number({ invalid_type_error: '표시 순서는 숫자여야 합니다' })
    .int('정수로 입력해주세요')
    .min(0, '0 이상이어야 합니다')
    .optional(),
  useYn: z.boolean().optional(),
  extraAttrs: z
    .string()
    .max(2000, '확장 속성은 2000자 이하여야 합니다')
    .optional(),
});

export type CodeItemUpdateFormValues = z.infer<typeof codeItemUpdateSchema>;
